import { GiTwoCoins } from "react-icons/gi";

type Props = {
    balance: string
}

const Balance = (props: Props) => {
    return (
        <div style={{marginBottom: 10}}>
                <div style={{marginBottom: -4}}>
                    Saldo <GiTwoCoins />
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5, marginBottom: 5, paddingTop: 5, paddingBottom: 5, width: '100%', backgroundColor: 'lightgray', borderRadius: 10 }}>
                    R$ {(''+props.balance).replace('.', ',')}
                </div>
            </div>
    )
}
export default Balance;